module.exports = __webpack_public_path__ + "static/iphone-29bc96f4bbf683002ccfb9b8af4ac727.png";